const TEMPLATE_NAME = 'FURNITURE_PEP';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: newData,
        filter: {
          ...state.filter,
          data: newData
        }
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          data: newData
        }
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: [...currentData, ...newData],
        filter: {
          ...state.filter,
          data: [...currentData, ...newData]
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
